/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template,camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import './Job.scss';

const Job = ({job, job_post}) => {
    let jobDetails = '';
    if(job.custom_fields.business_line) {
        jobDetails = job.custom_fields.business_line;
    }
    if(job.jobPost && job.jobPost.location.name && job.jobPost.location.name.length) {
        let locationName = job.jobPost.location.name;
        if(locationName.includes(',') && locationName.split(',').length > 2) {
            locationName = locationName.split(',')[0] + ', ' + locationName.split(',')[1];
        }
        jobDetails = jobDetails + ' | ' + locationName;
    }
    if(job.custom_fields.employment_type) {
        jobDetails = jobDetails + ' | ' + job.custom_fields.employment_type;
    }

    const jobSlug = job.jobPost.title.trim().replace(' -', '').replace(/\W/g, '-').toLowerCase();

    // const isRemote = !!job_post && job_post.location && job_post.location.name && job_post.location.name.toLowerCase() === 'remote';
    // console.log(job_post);
    // console.log(isRemote);

    return (
        <div key={job.id} className="job">
            <div className="jobInfo">
                <span className="jobInfo--name">{job.jobPost.title}</span>
                <span className="jobInfo--details">{jobDetails}</span>
            </div>
            <div className="jobCta">

                <a href={`/careers/current-openings/detail/${jobSlug}-${job.id}?gh_jid=${job_post.id}`} className="button button--ghost">View Job</a>
            </div>
        </div>
    );
}

Job.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    job: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    job_post: PropTypes.object.isRequired
}

export default Job;



// WEBPACK FOOTER //
// ./frontend/components/Jobs/Job.jsx